import { render, staticRenderFns } from "./OverviewDocument.vue?vue&type=template&id=27273b33&scoped=true"
import script from "./OverviewDocument.vue?vue&type=script&lang=js"
export * from "./OverviewDocument.vue?vue&type=script&lang=js"
import style0 from "./OverviewDocument.vue?vue&type=style&index=0&id=27273b33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27273b33",
  null
  
)

export default component.exports